import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { CartPromo } from '#src/components/cart/CartPromo/index.tsx';
import { filterLivePromos } from '#src/lib/promotionalEvent.ts';

import type { CartPromos_cart } from './__generated__/index.graphql.ts';

type Props = {
  cart: CartPromos_cart;
};

export const CartPromos = ({ cart }: Props) => {
  const liveDetailedPromos = filterLivePromos(
    cart.activePromotionalEvents || [],
    cart.sport
  );

  return liveDetailedPromos.map(promo => (
    <CartPromo key={promo.slug} cartPurchaseRewardPromotionalEvent={promo} />
  ));
};

CartPromos.fragments = {
  cart: gql`
    fragment CartPromos_cart on Cart {
      id
      sport
      activePromotionalEvents {
        slug
        endDate
        startDate
        sport
        ...CartPromo_cartPurchaseRewardPromotionalEvent
      }
    }
    ${CartPromo.fragments.cartPurchaseRewardPromotionalEvent}
  ` as TypedDocumentNode<CartPromos_cart>,
};
